import {Injector, NgModule} from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import {ContextFieldsComponent} from './context-fields.component';
import {createCustomElement} from "@angular/elements";
import {MatDialogModule} from "@angular/material/dialog";
import {MatInputModule} from "@angular/material/input";
import {ReactiveFormsModule} from "@angular/forms";
import {MatMenuModule} from "@angular/material/menu";
import {MatTableModule} from "@angular/material/table";
import {MatTreeModule} from "@angular/material/tree";
import {MatButtonModule} from "@angular/material/button";
import {FileUploadUIModule} from "@signature-it/ngx-generic/components/forms/file-upload";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {RouterModule} from "@angular/router";
import {ParseUrlPipeModule, ReplaceTokensPipeArrayModule, SafePipeModule} from "@signature-it/ngx-generic/pipes";
import {PriceModule_Catalogue} from '@signature-it/ngx-catalogue/components/price';
@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatTableModule,
        MatTreeModule,
        MatButtonModule,
        FileUploadUIModule,
        MatDialogModule,
        MatIconModule,
        MatMenuModule,
        MatInputModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        SafePipeModule,
        PriceModule_Catalogue
    ],
    declarations: [ContextFieldsComponent],
    exports: [ContextFieldsComponent]
})

export class ContextFieldsModule {
    constructor(private injector: Injector) {
        const WidgetAreaComp = createCustomElement(ContextFieldsComponent, {injector});
        !customElements.get('ngx-context-fields') && customElements.define('ngx-context-fields', WidgetAreaComp);
    }
}
